module.exports = __webpack_public_path__ + "static/media/Ciderama_outside3small.7d5ffcc2.png";